import { InventoryItem, InventoryVarianceRow } from 'dtos/inventory/inventory.dto';
import { PaginatedResponse, toPaginatedResponse } from 'dtos/common/api.dto';
import { apiClient } from 'services/api-client';

export class InventoryService {
  static async list(orgId: string, storeId: string, page = 1, pageSize = 8, search?: string): Promise<PaginatedResponse<InventoryItem>> {
    const params = new URLSearchParams({ page: String(page), pageSize: String(pageSize) });
    if (search) params.set('search', search);
    const response = await apiClient.get<InventoryItem[]>(`/orgs/${orgId}/stores/${storeId}/inventory?${params}`);
    return toPaginatedResponse(response, page, pageSize);
  }

  static async getVariances(orgId: string, storeId: string, page = 1, pageSize = 8): Promise<PaginatedResponse<InventoryVarianceRow>> {
    const response = await apiClient.get<InventoryVarianceRow[]>(`/orgs/${orgId}/stores/${storeId}/inventory/variance?page=${page}&pageSize=${pageSize}`);
    return toPaginatedResponse(response, page, pageSize);
  }

  static async submitCount(orgId: string, storeId: string, productId: string, physicalCount: number, notes?: string): Promise<void> {
    await apiClient.post(`/orgs/${orgId}/stores/${storeId}/inventory/counts`, { product_id: productId, physical_count: physicalCount, notes });
  }
}

